/**
 * Learn more about theme events at
 * https://help.switchthemes.co/shapes/developer/theme-events/overview.html
 */

console.log('📄 [THEME EVENTS] theme-events.js loaded');

window.theme = window.theme || {};

window.theme.events = {
  version: '1.0',
};

/**
 * BUNDLE VIEWPORT DETECTION FOR STICKY CART & FLOATING PANEL
 * This code controls when the sticky add-to-cart button is visible on desktop
 * and when the floating bundle panel is visible on mobile.
 *
 * CSS hides the floating panel by default on mobile.
 * JavaScript shows it only when the bundle widget is in the viewport.
 *
 * Desktop: Shows sticky cart when bundle widget is visible
 * Mobile: Shows floating panel when bundle widget is visible
 *
 * This prevents showing UI elements unnecessarily when users are not
 * actively viewing the bundle section.
 */
// Poll for bundle element since Rebuy loads asynchronously
function waitForBundle(callback, maxAttempts = 50) {
  let attempts = 0;

  const checkForBundle = () => {
    attempts++;
    const hasBundle = document.querySelector('.rebuy-bundle-builder');

    if (hasBundle) {
      console.log('✅ [BUNDLE DETECTION] Bundle found after', attempts, 'attempts');
      callback();
    } else if (attempts < maxAttempts) {
      // Check again in 100ms
      setTimeout(checkForBundle, 100);
    } else {
      console.log('❌ [BUNDLE DETECTION] Bundle not found after', maxAttempts, 'attempts, giving up');
    }
  };

  checkForBundle();
}

// Mobile bundle visibility is now handled by CSS
function setupMobileBundleVisibility() {
  // CSS handles hiding by default, JavaScript only shows when needed
}

// Run immediately or on DOMContentLoaded
function initializeBundleDetection() {
  console.log('🔍 [BUNDLE] initializeBundleDetection called');

  // Always try to wait for bundle, even if it's not there yet
  // The bundle loads asynchronously after the page loads
  console.log('🚀 [BUNDLE] Starting waitForBundle');

  // Wait for bundle to load asynchronously
  waitForBundle(() => {
    console.log('✅ [BUNDLE] waitForBundle callback fired');
    // Find the main bundle widget to track
    const bundleWidget = document.querySelector('.rebuy-widget');
    if (!bundleWidget) {
      return;
    }

    // Set up IntersectionObserver to detect when main bundle widget is in viewport
    const bundleObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const isWidgetVisible = entry.isIntersecting;

        // Control floating panel visibility - show when bundle widget is in viewport
        const floatingPanel = document.querySelector('.rebuy-bundle-builder__group-container');
        let panelIsVisible = false;

        console.log('🔍 [PANEL] Looking for floating panel element...');
        console.log('🔍 [PANEL] Found element:', !!floatingPanel);

        if (floatingPanel) {
          console.log('📋 [PANEL] Element details:', {
            tagName: floatingPanel.tagName,
            className: floatingPanel.className,
            id: floatingPanel.id,
            currentDisplay: floatingPanel.style.display,
            computedDisplay: window.getComputedStyle(floatingPanel).display,
            offsetHeight: floatingPanel.offsetHeight,
            offsetWidth: floatingPanel.offsetWidth
          });

          // Show panel when bundle widget is visible (active), hide when not visible
          const shouldShowPanel = isWidgetVisible;
          console.log('📱 [PANEL] Bundle widget active (visible):', isWidgetVisible, '→ should show panel:', shouldShowPanel);

          if (shouldShowPanel) {
            // Remove fade-complete class and ensure display is block
            floatingPanel.classList.remove('bundle-panel-fade-complete');
            floatingPanel.style.display = 'block';
            
            // Start with hidden state for fade-in animation
            floatingPanel.classList.remove('bundle-panel-visible');
            floatingPanel.classList.add('bundle-panel-hidden');
            
            // Force a reflow to ensure the hidden state is applied
            void floatingPanel.offsetHeight;
            
            // Now trigger the fade-in transition by switching to visible
            requestAnimationFrame(() => {
              floatingPanel.classList.remove('bundle-panel-hidden');
              floatingPanel.classList.add('bundle-panel-visible');
              document.body.classList.add('bundle-panel-active');
              console.log('✅ [PANEL] Panel SHOWN - bundle is active (animated with overlay)');
            });
          } else {
            // Trigger fade-out transition by switching classes
            floatingPanel.classList.remove('bundle-panel-visible');
            floatingPanel.classList.add('bundle-panel-hidden');
            document.body.classList.remove('bundle-panel-active');
            console.log('❌ [PANEL] Panel HIDDEN - bundle not active (overlay removed)');
            
            // After fade-out transition completes (400ms), set display: none
            setTimeout(() => {
              floatingPanel.classList.add('bundle-panel-fade-complete');
            }, 400);
          }

          console.log('📊 [PANEL] Classes applied:', floatingPanel.className);

          // Check if panel is actually visible by checking for the visible class
          // (not display property, since we keep display: block during fade-out)
          panelIsVisible = floatingPanel.classList.contains('bundle-panel-visible') && 
                          !floatingPanel.classList.contains('bundle-panel-fade-complete');
          console.log('📊 [PANEL] Final panel visibility:', panelIsVisible);
        } else {
          console.log('❌ [PANEL] Floating panel element not found - checking all similar elements...');
          const allSimilar = document.querySelectorAll('[class*="group-container"], [class*="bundle"]');
          console.log('🔍 [PANEL] Found similar elements:', allSimilar.length);
          allSimilar.forEach((el, i) => {
            console.log(`🔍 [PANEL] Similar element ${i}:`, el.className, el.tagName);
          });
        }

        // CRITICAL: ALWAYS hide sticky cart when floating panel is visible - NO EXCEPTIONS
        const stickyCart = document.querySelector('#sticky-add-to-cart');
        if (stickyCart) {
          console.log('🔍 [STICKY] Checking sticky cart visibility...');
          console.log('📊 [STICKY] Panel is visible:', panelIsVisible);
          console.log('📊 [STICKY] Widget is visible:', isWidgetVisible);
          console.log('📊 [STICKY] Current sticky cart classes:', stickyCart.className);

          if (panelIsVisible || isWidgetVisible) {
            // ABSOLUTE RULE: If ANY bundle element is visible, ALWAYS hide sticky cart
            // This includes both the floating panel AND the main bundle widget
            stickyCart.classList.remove('is-visible');
            stickyCart.classList.add('sticky-cart-force-hidden');
            stickyCart.style.setProperty('display', 'none', 'important');
            console.log('🚫 [STICKY] ABSOLUTELY HIDDEN - bundle element visible (panel:', panelIsVisible, 'widget:', isWidgetVisible, ')');
          } else {
            // NO bundle elements are visible - allow NORMAL sticky cart behavior
            stickyCart.classList.remove('sticky-cart-force-hidden');
            stickyCart.style.removeProperty('display'); // Remove all forced hiding

            const isMobile = window.innerWidth < 768;
            if (isMobile) {
              // On mobile: let sticky cart work normally (original sticky cart logic will handle this)
              console.log('📱 [STICKY] Mobile - allowing normal sticky cart behavior (no bundle visible)');
            } else {
              // On desktop: only show when scrolled past threshold (original logic)
              stickyCart.classList.remove('is-visible');
              console.log('💻 [STICKY] Desktop - allowing normal scroll-based behavior (no bundle visible)');
            }
          }

          console.log('📊 [STICKY] Final sticky cart classes:', stickyCart.className);
          console.log('📊 [STICKY] Final sticky cart display:', window.getComputedStyle(stickyCart).display);
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    });

    // Start observing the main bundle widget
    bundleObserver.observe(bundleWidget);

    // Check initial state and apply to floating panel
    setTimeout(() => {
      const rect = bundleWidget.getBoundingClientRect();
      const isInitiallyVisible = rect.top < window.innerHeight && rect.bottom > 0;

      const floatingPanel = document.querySelector('.rebuy-bundle-builder__group-container');
      if (floatingPanel) {
        // Remove any inline display styles and use class-based system
        floatingPanel.style.removeProperty('display');
        if (isInitiallyVisible) {
          floatingPanel.classList.remove('bundle-panel-hidden', 'bundle-panel-fade-complete');
          floatingPanel.classList.add('bundle-panel-visible');
          document.body.classList.add('bundle-panel-active');
        } else {
          floatingPanel.classList.remove('bundle-panel-visible');
          floatingPanel.classList.add('bundle-panel-hidden', 'bundle-panel-fade-complete');
          document.body.classList.remove('bundle-panel-active');
        }
      }
    }, 1000);
  });
}

/**
 * SEAL SUBSCRIPTIONS QUANTITY-BASED PRICING
 * Updates Seal Subscriptions prices based on quantity
 * Prices only update when quantity changes, NOT when selling plan changes
 */
(function() {
  'use strict';

  // Store base price per unit (one-time, never discounted)
  let cachedBasePricePerUnit = null;

  // Get price per unit in cents - ALWAYS returns base one-time price (never discounted)
  const getPricePerUnitInCents = () => {
    // If we have a cached base price, use it (prevents using discounted prices)
    if (cachedBasePricePerUnit !== null) {
      return cachedBasePricePerUnit;
    }

    // Try to get from Seal Subscriptions data attributes (this should be base price)
    const sealsubsElements = document.querySelectorAll('.sealsubs-target-element');
    for (const element of sealsubsElements) {
      if (element._sealsubs && element._sealsubs.price) {
        cachedBasePricePerUnit = element._sealsubs.price;
        return cachedBasePricePerUnit;
      }
      if (element.dataset && element.dataset.price) {
        const price = parseInt(element.dataset.price);
        if (!isNaN(price)) {
          cachedBasePricePerUnit = price;
          return cachedBasePricePerUnit;
        }
      }
    }

    // Get from Seal widget one-time price (this is always base price, never discounted)
    const sealContainer = document.querySelector('.sls-purchase-options-container');
    if (sealContainer) {
      const oneTimePriceEl = sealContainer.querySelector('.sls-one-time-price .money');
      if (oneTimePriceEl) {
        const priceText = oneTimePriceEl.textContent.trim();
        const priceMatch = priceText.replace(/[^\d.,]/g, '').replace(',', '.');
        const priceValue = parseFloat(priceMatch);
        if (!isNaN(priceValue) && priceValue > 0) {
          cachedBasePricePerUnit = Math.round(priceValue * 100);
          return cachedBasePricePerUnit;
        }
      }
    }

    // Last resort: use lastSealSubsPrice only if we have no other option
    // But be careful - this might be discounted, so we'll recalculate if needed
    if (window.lastSealSubsPrice) {
      // If we're getting this, it might be discounted, so we'll use it but mark it as potentially wrong
      return window.lastSealSubsPrice;
    }

    return null;
  };

  // Format price using same logic as sticky-add-to-cart
  const formatMoney = (priceInCents) => {
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(priceInCents);
    }
    // Fallback: try to get currency from existing prices
    const existingPrice = document.querySelector('.money, [data-product-price], .price');
    let currencySymbol = '';
    if (existingPrice) {
      const priceText = existingPrice.textContent.trim();
      const currencyMatch = priceText.match(/^[£$€¥₹₽₩₪₫₨₦₡₨₩₪₫₨₦₡]/);
      if (currencyMatch) {
        currencySymbol = currencyMatch[0];
      }
    }
    const price = priceInCents / 100;
    return `${currencySymbol}${price.toFixed(2)}`;
  };

  // Get discount percentage from Seal widget by comparing prices
  const getSealDiscountPercentage = () => {
    const sealContainer = document.querySelector('.sls-purchase-options-container');
    if (!sealContainer) return null;

    // Try to get from widget data attributes first
    const sealsubsElement = document.querySelector('.sealsubs-target-element[data-product]');
    if (sealsubsElement && sealsubsElement.dataset.product) {
      try {
        const productData = JSON.parse(sealsubsElement.dataset.product);
        if (productData.selling_plan_groups && productData.selling_plan_groups.length > 0) {
          const sellingPlanGroup = productData.selling_plan_groups[0];
          if (sellingPlanGroup.selling_plans && sellingPlanGroup.selling_plans.length > 0) {
            const sellingPlan = sellingPlanGroup.selling_plans[0];
            if (sellingPlan.price_adjustments && sellingPlan.price_adjustments.length > 0) {
              const adjustment = sellingPlan.price_adjustments[0];
              if (adjustment.value_type === 'percentage' && adjustment.value) {
                return parseFloat(adjustment.value) / 100; // Convert 15 to 0.15
              }
            }
          }
        }
      } catch (e) {
        // Fall through to price comparison method
      }
    }

    // Fallback: Calculate from displayed prices (when quantity is 1)
    const oneTimePriceEl = sealContainer.querySelector('.sls-one-time-price .money');
    const subscriptionPriceEl = sealContainer.querySelector('.sls-selling-plan-group-price .sls-price .money');
    
    if (oneTimePriceEl && subscriptionPriceEl) {
      const oneTimeText = oneTimePriceEl.textContent.trim();
      const subscriptionText = subscriptionPriceEl.textContent.trim();
      
      const oneTimeMatch = oneTimeText.replace(/[^\d.,]/g, '').replace(',', '.');
      const subscriptionMatch = subscriptionText.replace(/[^\d.,]/g, '').replace(',', '.');
      
      const oneTimeValue = parseFloat(oneTimeMatch);
      const subscriptionValue = parseFloat(subscriptionMatch);
      
      if (!isNaN(oneTimeValue) && !isNaN(subscriptionValue) && oneTimeValue > 0) {
        const discount = 1 - (subscriptionValue / oneTimeValue);
        return discount; // Returns 0.15 for 15% discount
      }
    }

    return null;
  };

  // Cache the discount percentage
  let cachedDiscountPercentage = null;

  // Update Seal Subscriptions prices based on quantity
  const updateSealPrices = (quantity) => {
    const sealContainer = document.querySelector('.sls-purchase-options-container');
    if (!sealContainer) return;

    // Get BASE price per unit (one-time, never discounted)
    // Always use cached base price or get it fresh from data attributes
    // Never use displayed prices as they might already be quantity-adjusted
    let pricePerUnit = getPricePerUnitInCents();
    
    // If we can't get base price, try to extract from widget data
    if (!pricePerUnit) {
      const sealsubsElement = document.querySelector('.sealsubs-target-element[data-product]');
      if (sealsubsElement && sealsubsElement.dataset.product) {
        try {
          const productData = JSON.parse(sealsubsElement.dataset.product);
          if (productData.variants && productData.variants.length > 0) {
            const variant = productData.variants[0];
            if (variant.price) {
              cachedBasePricePerUnit = variant.price;
              pricePerUnit = variant.price;
            }
          }
        } catch (e) {
          // Ignore parse errors
        }
      }
    }
    
    if (!pricePerUnit) return;

    // Get discount percentage (cache it to avoid recalculating)
    if (cachedDiscountPercentage === null) {
      cachedDiscountPercentage = getSealDiscountPercentage();
      // If we still can't get it, default to 0.15 (15%) as fallback
      if (cachedDiscountPercentage === null) {
        cachedDiscountPercentage = 0.15;
      }
    }

    // Calculate prices from BASE price
    // One-time: base * quantity (NO discount)
    const oneTimeTotalCents = pricePerUnit * quantity;
    // Subscription: base * quantity * (1 - discount) (apply discount once)
    const subscriptionTotalCents = Math.round(oneTimeTotalCents * (1 - cachedDiscountPercentage));
    // Original subscription price (before discount) = one-time price
    const subscriptionOriginalTotalCents = oneTimeTotalCents;

    // Format prices
    const oneTimeFormatted = formatMoney(oneTimeTotalCents);
    const subscriptionFormatted = formatMoney(subscriptionTotalCents);
    const subscriptionOriginalFormatted = formatMoney(subscriptionOriginalTotalCents);

    // Get price elements
    const oneTimePriceEl = sealContainer.querySelector('.sls-one-time-price .money');
    const subscriptionPriceEl = sealContainer.querySelector('.sls-selling-plan-group-price .sls-price .money');
    const subscriptionOriginalPriceEl = sealContainer.querySelector('.sls-selling-plan-group-price .sls-original-price .money');

    // Update one-time price (always base * quantity, no discount)
    if (oneTimePriceEl) {
      oneTimePriceEl.textContent = oneTimeFormatted;
    }

    // Update subscription prices
    if (subscriptionPriceEl) {
      subscriptionPriceEl.textContent = subscriptionFormatted;
    }
    if (subscriptionOriginalPriceEl) {
      subscriptionOriginalPriceEl.textContent = subscriptionOriginalFormatted;
    }
  };

  // Get the add-to-cart button price element
  const getAddToCartPriceElement = () => {
    const addToCartButton = document.querySelector('.add-to-cart-btn');
    if (!addToCartButton) return null;

    // Find the price element inside the button
    // The structure is: <span x-html="formatMoney(currentPrice)"><span class="money">£20.39</span></span>
    const priceSpan = Array.from(addToCartButton.querySelectorAll('span')).find(span => {
      const htmlAttr = span.getAttribute('x-html');
      return htmlAttr && htmlAttr.includes('formatMoney(currentPrice)');
    });
    
    if (!priceSpan) return null;
    
    const moneyElement = priceSpan.querySelector('.money');
    return moneyElement || priceSpan;
  };

  // Update add-to-cart button price based on selected option in Seal widget
  const updateAddToCartButtonPrice = (quantity) => {
    const priceElement = getAddToCartPriceElement();
    if (!priceElement) return;

    // Get price directly from Seal widget based on selected option
    const sealContainer = document.querySelector('.sls-purchase-options-container');
    if (!sealContainer) return;

    // Check which option is selected
    const subscriptionOption = sealContainer.querySelector('.sls-option-container.sls-active[data-selling-plan-group]');
    const isSubscriptionSelected = subscriptionOption && subscriptionOption.classList.contains('sls-active');
    
    let priceText = null;
    
    if (isSubscriptionSelected) {
      // Get subscription price from widget
      const subscriptionPriceEl = sealContainer.querySelector('.sls-selling-plan-group-price .sls-price .money');
      if (subscriptionPriceEl) {
        priceText = subscriptionPriceEl.textContent.trim();
      }
    } else {
      // Get one-time price from widget
      const oneTimePriceEl = sealContainer.querySelector('.sls-one-time-price .money');
      if (oneTimePriceEl) {
        priceText = oneTimePriceEl.textContent.trim();
      }
    }

    // Update the button price with the price from the widget
    if (priceText) {
      priceElement.textContent = priceText;
    }
  };

  // Store current add-to-cart button price
  let currentAddToCartButtonPrice = null;

  // Update add-to-cart button price with storage
  const updateAddToCartButtonPriceWithStorage = (quantity) => {
    updateAddToCartButtonPrice(quantity);
    
    // Store the price we just set
    const priceElement = getAddToCartPriceElement();
    if (priceElement) {
      currentAddToCartButtonPrice = priceElement.textContent;
    }
  };

  // Restore stored add-to-cart button price instantly
  const restoreAddToCartButtonPrice = () => {
    if (!currentAddToCartButtonPrice) return;
    
    const priceElement = getAddToCartPriceElement();
    if (priceElement) {
      // Restore immediately and synchronously
      priceElement.textContent = currentAddToCartButtonPrice;
    }
  };

  // Debounce helper to prevent rapid updates
  let quantityUpdateTimeout = null;
  let isUpdating = false;
  let lastQuantity = null;

  // Handle quantity changes with optimized debouncing
  const handleQuantityChange = () => {
    const quantityInput = document.querySelector('input[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    
    // If quantity hasn't changed, skip
    if (quantity === lastQuantity) return;
    lastQuantity = quantity;
    
    // Prevent concurrent updates
    if (isUpdating) {
      // Clear pending timeout and schedule new one
      if (quantityUpdateTimeout) {
        clearTimeout(quantityUpdateTimeout);
      }
      quantityUpdateTimeout = setTimeout(() => handleQuantityChange(), 50);
      return;
    }
    
    // Clear any pending updates
    if (quantityUpdateTimeout) {
      clearTimeout(quantityUpdateTimeout);
      quantityUpdateTimeout = null;
    }
    
    // Update immediately for first change, debounce rapid subsequent changes
    isUpdating = true;
    try {
      updateSealPricesWithStorage(quantity); // Use version that stores prices
      updateAddToCartButtonPriceWithStorage(quantity); // Update and store add-to-cart button price
    } finally {
      // Small delay before allowing next update to prevent race conditions
      setTimeout(() => {
        isUpdating = false;
      }, 10);
    }
  };

  // Set up quantity listeners
  const setupQuantityListeners = () => {
    const quantityInputs = document.querySelectorAll('input[name="quantity"]');
    quantityInputs.forEach((input) => {
      if (input.name && input.name.includes('updates')) return; // Skip cart inputs
      
      input.addEventListener('change', handleQuantityChange);
      input.addEventListener('input', handleQuantityChange);
    });

    // Also watch quantity buttons
    const quantityButtons = document.querySelectorAll('button.quantity-button');
    quantityButtons.forEach((button) => {
      button.addEventListener('click', () => {
        handleQuantityChange();
      });
    });
  };

  // Store current quantity-based prices so we can restore them instantly
  let currentQuantityBasedPrices = null;

  // Update the stored prices whenever quantity changes
  const updateSealPricesWithStorage = (quantity) => {
    updateSealPrices(quantity);
    
    // Store the prices we just set
    const sealContainer = document.querySelector('.sls-purchase-options-container');
    if (sealContainer) {
      const oneTimePriceEl = sealContainer.querySelector('.sls-one-time-price .money');
      const subscriptionPriceEl = sealContainer.querySelector('.sls-selling-plan-group-price .sls-price .money');
      const subscriptionOriginalPriceEl = sealContainer.querySelector('.sls-selling-plan-group-price .sls-original-price .money');
      
      if (oneTimePriceEl && subscriptionPriceEl && subscriptionOriginalPriceEl) {
        currentQuantityBasedPrices = {
          oneTime: oneTimePriceEl.textContent,
          subscription: subscriptionPriceEl.textContent,
          subscriptionOriginal: subscriptionOriginalPriceEl.textContent
        };
      }
    }
  };

  // Restore stored prices instantly (no calculation, just restore text)
  const restoreStoredPrices = () => {
    if (!currentQuantityBasedPrices) return;
    
    const sealContainer = document.querySelector('.sls-purchase-options-container');
    if (!sealContainer) return;
    
    const oneTimePriceEl = sealContainer.querySelector('.sls-one-time-price .money');
    const subscriptionPriceEl = sealContainer.querySelector('.sls-selling-plan-group-price .sls-price .money');
    const subscriptionOriginalPriceEl = sealContainer.querySelector('.sls-selling-plan-group-price .sls-original-price .money');
    
    // Restore immediately and synchronously
    if (oneTimePriceEl && currentQuantityBasedPrices.oneTime) {
      oneTimePriceEl.textContent = currentQuantityBasedPrices.oneTime;
    }
    if (subscriptionPriceEl && currentQuantityBasedPrices.subscription) {
      subscriptionPriceEl.textContent = currentQuantityBasedPrices.subscription;
    }
    if (subscriptionOriginalPriceEl && currentQuantityBasedPrices.subscriptionOriginal) {
      subscriptionOriginalPriceEl.textContent = currentQuantityBasedPrices.subscriptionOriginal;
    }
  };

  // Listen for Seal widget creation - refresh discount cache
  document.addEventListener('sealsubs:subscription_widget_created', () => {
    // Refresh discount percentage cache when widget is created
    cachedDiscountPercentage = null;
    cachedBasePricePerUnit = null; // Reset base price cache
    getSealDiscountPercentage(); // This will cache it
    
    // Update and store add-to-cart button price
    requestAnimationFrame(() => {
      const quantityInput = document.querySelector('input[name="quantity"]');
      const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
      updateSealPricesWithStorage(quantity);
      updateAddToCartButtonPriceWithStorage(quantity);
    });
  });

  // Listen for Seal price updates - IMMEDIATELY restore stored prices (no calculation)
  document.addEventListener('sealsubs:price_update', (e) => {
    // Store the price for future use
    if (e.detail && e.detail.price) {
      window.lastSealSubsPrice = e.detail.price;
    }
    
    // Refresh discount cache in case it changed
    cachedDiscountPercentage = null;
    getSealDiscountPercentage(); // This will cache it
    
    // Restore stored prices IMMEDIATELY and synchronously (no delay, no calculation)
    restoreStoredPrices();
    restoreAddToCartButtonPrice(); // Restore add-to-cart button price
    
    // Also restore in next frame as backup
    requestAnimationFrame(() => {
      restoreStoredPrices();
      restoreAddToCartButtonPrice();
    });
  });

  // Listen for selling plan changes - update add-to-cart button price based on new selection
  document.addEventListener('sealsubs:selling_plan_changed', () => {
    // Refresh discount cache in case it changed with the plan
    cachedDiscountPercentage = null;
    getSealDiscountPercentage(); // This will cache it
    
    // Restore Seal widget prices IMMEDIATELY (these should stay at quantity-based prices)
    restoreStoredPrices();
    
    // Update add-to-cart button price based on the NEWLY selected option
    const quantityInput = document.querySelector('input[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    
    // Update the price based on current selection and store it
    updateAddToCartButtonPriceWithStorage(quantity);
    
    // Also restore Seal prices in next frame as backup
    requestAnimationFrame(() => {
      restoreStoredPrices();
      // Ensure add-to-cart button has the correct price for the new selection
      updateAddToCartButtonPriceWithStorage(quantity);
    });
  });

  // Set up MutationObserver to catch price changes and restore instantly
  const setupPriceRestoreObserver = () => {
    const sealContainer = document.querySelector('.sls-purchase-options-container');
    if (!sealContainer) {
      setTimeout(setupPriceRestoreObserver, 500);
      return;
    }

    const priceElements = [
      sealContainer.querySelector('.sls-one-time-price .money'),
      sealContainer.querySelector('.sls-selling-plan-group-price .sls-price .money'),
      sealContainer.querySelector('.sls-selling-plan-group-price .sls-original-price .money')
    ].filter(el => el !== null);

    if (priceElements.length === 0) {
      setTimeout(setupPriceRestoreObserver, 500);
      return;
    }

    // Track last values
    const lastValues = new Map();
    priceElements.forEach(el => {
      lastValues.set(el, el.textContent);
    });

    // Observer that restores prices instantly when Seal changes them
    const observer = new MutationObserver(() => {
      // Check if prices changed (Seal updated them)
      let changed = false;
      priceElements.forEach(el => {
        const current = el.textContent.trim();
        const last = lastValues.get(el);
        if (current !== last && current !== '' && last !== undefined) {
          changed = true;
          lastValues.set(el, current);
        }
      });

      // If prices changed and we have stored prices, restore them immediately
      if (changed && currentQuantityBasedPrices) {
        restoreStoredPrices();
        restoreAddToCartButtonPrice(); // Also restore add-to-cart button price
        // Update tracked values after restore
        priceElements.forEach(el => {
          lastValues.set(el, el.textContent);
        });
      }
    });

    observer.observe(sealContainer, {
      childList: true,
      subtree: true,
      characterData: true
    });
  };

  // Initialize
  const init = () => {
    setupQuantityListeners();
    setupPriceRestoreObserver();
    handleQuantityChange(); // Initial update
  };

  // Wait for DOM and Seal to load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(init, 1000);
    });
  } else {
    setTimeout(init, 1000);
  }
})();

// Since this script is loaded with async defer, run when script executes
// DOMContentLoaded may have already fired, so check readyState
if (document.readyState === 'loading') {
  // DOM still loading, wait for it
  document.addEventListener('DOMContentLoaded', () => {
    initializeBundleDetection();
  });
} else {
  // DOM already loaded, run immediately
  initializeBundleDetection();
}

document.addEventListener('theme:update:cart', async () => {
  document.dispatchEvent(new CustomEvent('shapes:cart:lock'));

  try {
    const response = await fetch(
      `${window.location.pathname}?sections=cart-items,cart-footer,cart-item-count,cart-live-region`
    );
    const data = await response.json();

    if (!data.status) {
      document.dispatchEvent(
        new CustomEvent('shapes:cart:update', {
          bubbles: true,
          detail: {
            response: {
              sections: {
                ...data,
              },
            },
          },
        })
      );
    }
  } catch (e) {
    console.error(e);
    document.getElementById('cart-errors').textContent =
      theme.strings.cartError;
    document.dispatchEvent(
      new CustomEvent('theme:cart:error:other', {
        detail: {
          message: theme.strings.cartError,
          error: e,
        },
      })
    );
  } finally {
    document.dispatchEvent(new CustomEvent('shapes:cart:unlock'));
  }
});

const getCartDrawerEl = () => {
  return document.querySelector('[data-cart-drawer]');
};

document.addEventListener('cart-will-open', async () => {
  const cartDrawerEl = getCartDrawerEl();

  const detail = {
    cartDrawerEl,
  };

  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:opening', {
      detail,
    })
  );
});

document.addEventListener('cart-is-open', async () => {
  const cartDrawerEl = getCartDrawerEl();

  const detail = {
    cartDrawerEl,
  };

  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:open', {
      detail,
    })
  );
});

document.addEventListener('cart-will-close', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closing', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.addEventListener('cart-is-closed', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closed', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.addEventListener('theme:open:cart-drawer', () => {
  if (
    window.theme.settings.cart_type === 'modal' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').closeAll();

    Alpine.store('modals').open('cart');
  }
});

document.addEventListener('theme:close:cart-drawer', () => {
  if (
    window.theme.settings.cart_type === 'modal' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').close('cart');
  }
});

const cartChangeEventHandler = (e) => {
  const { cartItemCount, itemsRootEl, lineItemEl, variantId, key } = e.detail;

  document.dispatchEvent(
    new CustomEvent('theme:cart:change', {
      detail: {
        type: e.type,
        cartItemCount,
        itemsRootEl,
        lineItemEl,
        variantId,
        key,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener('theme:product:add', cartChangeEventHandler);
document.addEventListener('theme:line-item:change', cartChangeEventHandler);

const cartErrorEventHandler = (e) => {
  document.dispatchEvent(
    new CustomEvent('theme:cart:error', {
      detail: {
        type: e.type,
        message: e.detail.message,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener(
  'theme:product:error:add-to-cart',
  cartErrorEventHandler
);

document.addEventListener('theme:line-item:error', cartErrorEventHandler);
document.addEventListener('theme:cart:error:other', cartErrorEventHandler);

/**
 * Set `window.themeEventsDebugMode` to `true` to log events
 * outside the theme editor
 */

if (Shopify.designMode || window.themeEventsDebugMode) {
  const themeEvents = [
    'theme:variant:change',
    'theme:product:add',
    'theme:line-item:change',
    'theme:cart:change',
    'theme:cart:update',
    'theme:cart-drawer:opening',
    'theme:cart-drawer:open',
    'theme:cart-drawer:closing',
    'theme:cart-drawer:closed',
    'theme:product:error:add-to-cart',
    'theme:line-item:error',
    'theme:cart:error:other',
    'theme:cart:error',
  ];

  const aggregateEvents = ['theme:cart:change', 'theme:cart:error'];

  for (const eventName of themeEvents) {
    let color;

    if (eventName.includes('error')) {
      color = '#ef4444';
    } else {
      color = '#22c55e';
    }

    const message = [
      `%c\u25CF %c${eventName}`,
      `color: ${color};`,
      'font-weight: bold;',
    ];

    if (aggregateEvents.includes(eventName)) {
      document.addEventListener(eventName, (e) => {
        console.groupCollapsed(...message);
        console.log(
          `Underlying event: %c${e.detail.type}`,
          'font-weight: bold;'
        );
        console.log('Event detail:', e.detail);
        console.groupEnd();
      });
    } else {
      document.addEventListener(eventName, (e) => {
        console.log(...message, e.detail);
      });
    }
  }
}
